import { hasInternalPermission } from "@/stores/user";
import type { MiddlewareContext } from "@/types";
import { useUserStore } from "@/stores/user";

export const hasInternalPermissionCanPlaceInternalOrder = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();

  if (!hasInternalPermission(store, "can_place_internal_order")) {
    router.push({ name: "PageRestricted" });
    return;
  }
  return next();
};
